import styled from 'styled-components';
import Empty from '../../../Empty';

const StyledInvoiceTabsContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  padding: 24px;
  position: relative;
  transition: .3s ease-in-out;
  
  .unmatched-totals {
    margin-left: 60px;
  }
`;

const StyledInvoicesTabsContent = styled.div`
  position: relative;
  width: 100%;
  
  .ant-tabs-content-holder {
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    min-height: unset;
  }
`;

const StyledInvoicesTabsEmpty = styled(Empty)`
  margin-top: 0;
  
  .ant-empty-description {
    & > div {
      max-width: 620px;
    }
  }
`;

export {
  StyledInvoiceTabsContainer,
  StyledInvoicesTabsContent,
  StyledInvoicesTabsEmpty
}
